<template>
  <div class="apply_w site_content">
    <SiteBreadcrumb />

    <div class="content_w site_content bc_fff">
      <div class="prompt_title">您即将跳转进入第三方网站</div>
      <div class="prompt_title02">
        韶关市农村产权交易平台不对该网站的内容及真实性负责，请注意信息及财产安全
      </div>
      <div class="link">
        <div>{{url}}</div>
      </div>
      <div class="pay_margin fz12 text_center c_fff" @click="stepJump">
        <template>
          <div class="btn_title">继续跳转</div>
        </template>
      </div>
      <div class="countdown-container">
        <p>{{ count }}秒后自动前往该网站</p>
        <p
          @click="cancelCountdown"
          class="hover-effect"
          style="color: #0983cc; margin-left: 15px"
        >
          取消跳转
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import MyUpload from "@/components/my-upload/index.vue";
import UploadTip from "@/components/base/UploadTip.vue";
import PreviewImg from "@/components/base/PreviewImg.vue";
import SiteBreadcrumb from "@/components/base/SiteBreadcrumb.vue";
import { user_gee_web_init } from "@/api/public";
import { auction_apply } from "@/api/action";

import bus from "@/utils/bus";
import { isvalidPhone } from "@/utils";
import { isValidIdcard } from "@/utils/validFiled";

import { mapMutations, mapGetters, mapActions } from "vuex";
import {
  _input_l_50,
  _input_l_100,
  _input_l_150,
  _input_l_300,
  _input_l_500,
} from "@/utils/setting";

import ImportJs from "@/components/base/ImportJs.vue";
import { TradeMode } from "@/enums";
import AgreementRead from "@/components/template/AgreementRead.vue";

export default {
  components: {
    UploadTip,
    PreviewImg,
    ImportJs,
    SiteBreadcrumb,
    AgreementRead,
    MyUpload,
  },

  data() {
    return {
      url: "https://dihe.cn",
      count: 3, // 倒计时3秒
      timer: null, // 存储定时器
    };
  },
  computed: {
    ...mapGetters([
      "Bucket_pub",
      "Bucket_internal",
      "isOssComplete",
      "static_resource",
    ]),
    input_l_50() {
      return _input_l_50;
    },
    input_l_100() {
      return _input_l_100;
    },
    input_l_150() {
      return _input_l_150;
    },
    input_l_300() {
      return _input_l_300;
    },
    input_l_500() {
      return _input_l_500;
    },
  },
  watch: {},
  created() {},

  mounted() {
    this.startCountdown()
  },
  beforeDestroy() {
    // 组件销毁前清除定时器
    clearInterval(this.timer);
  },
  methods: {
    startCountdown() {
      console.log("this.count");
      this.timer = setInterval(() => {
        if (this.count <= 1) {
          console.log("this.count <= 1");
          this.redirect(); // 倒计时结束跳转
        } else {
          console.log("this.count > 1");
          this.count--;
        }
      }, 1000); // 每秒执行一次
    },
    cancelCountdown() {
      clearInterval(this.timer);
      // this.$emit('cancel') // 通知父组件已取消
    },
    stepJump(){
      window.open(this.url, "_blank");
    },
    redirect() {
      console.log("/jumpPrompt");
      clearInterval(this.timer);
      // 跳转逻辑，例如：
      // this.$router.push('/jumpPrompt')
      window.open(this.url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.countdown-container {
  font-size: 15px;
  text-align: center;
  margin: 20px;
  display: flex;
}
.hover-effect:hover {
  text-decoration: underline; /* 显示下划线 */
  cursor: pointer; /* 鼠标变成手形 */
  color: #0066cc; /* 悬停时文字颜色变化（可选） */
}
button {
  padding: 8px 16px;
  background: #f0f0f0;
  border: 1px solid #ccc;
  border-radius: 4px;
  cursor: pointer;
}
button:hover {
  background: #e0e0e0;
}
.apply_w {
  margin: 0 auto 10px auto;
  padding-top: 16px;
  .content_w {
    padding: 100px;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    text-align: center;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center; /* 水平居中 */
    .prompt_title {
      font-size: 26px;
      font-weight: 800;
    }
    .prompt_title02 {
      margin-top: 30px;
      font-size: 15px;
    }
    .link {
      margin-top: 16px;
      background-color: #efefef;
      width: 524px;
      height: 45px;
      border: 1px solid #bbbbbb;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      display: flex;
      align-items: center;
      padding-left: 15px;
    }
    .pay_margin {
      margin-top: 30px;
      width: 110px;
      height: 33px;
      padding: 6px 34px;
      background-color: #0983cc;
      cursor: pointer !important;
      .btn_title {
        font-size: 15px;
        margin-top: 8px;
      }
    }
  }
}
</style>
